import { render } from "./InternalEmails.vue?vue&type=template&id=c2c9c47e"
import script from "./InternalEmails.vue?vue&type=script&lang=ts"
export * from "./InternalEmails.vue?vue&type=script&lang=ts"
script.render = render

export default script